import { render, staticRenderFns } from "./ObiPage.vue?vue&type=template&id=6cae2bd2&"
import script from "./ObiPage.vue?vue&type=script&lang=js&"
export * from "./ObiPage.vue?vue&type=script&lang=js&"
import style0 from "./ObiPage.vue?vue&type=style&index=0&id=6cae2bd2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports